 
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useUser } from "./context/UserContext"; 
import "../Styles/Login.css";
import { fetchCrn, getBaseUrl } from "../api";

function Login() {

  const navigate = useNavigate();
  const { setLoggedInUser } = useUser(); // Use context to store the logged-in user
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // Add loading state
  const baseUrl = getBaseUrl();

  const handleLogin = async (e) => {
    e.preventDefault();

    setError(""); // Reset previous errors
    setLoading(true); // Start loading

    try {
      const crn = await fetchCrn();
      const payload = {
        user_id: username.trim(),
        password: password.trim(),
        crn: crn,
        object: "login",
      };
      // alert("baseUrl "+baseUrl);
      const response = await axios.post(`https://${baseUrl}/request`, payload);

      if (response.data.status === "00") {
        
        console.log("Login Successful:", response.data);
        setLoggedInUser(username); // ✅ Store user in Context
        // let logggedInUser=username;
        sessionStorage.removeItem("hasSeenPaymentPopup");
        const userDialKey = "dial_cnt_"+username; // Unique key for each user
        localStorage.setItem(userDialKey,response.data.dial_cnt);
          // ✅ Store user info in localStorage
          localStorage.setItem("user_id", username);
          localStorage.setItem("email", response.data.email || ""); 
          localStorage.setItem("dial_cnt", response.data.dial_cnt || "0");
          localStorage.setItem("username",response.data.name);
          console.log(response.data.name);
          // console.log(username);
          // console.log(response.data.email);
          try {
            const profileResponse = await axios.post(`https://${baseUrl}/request`, {
              crn,
              user_id: username,
              object: "profile",
              action: "R",  
            });
    
            console.log("Profile Response Data:", profileResponse.data); // ✅ Log entire API response
    
            // ✅ Check the actual structure of the response
            let mciId = null;
            if (profileResponse.data?.response && Array.isArray(profileResponse.data.response) && profileResponse.data.response.length > 0) {
              mciId = profileResponse.data.response[0]?.mci_id?.trim() || null;
            }
            localStorage.setItem("mciid",mciId);
            console.log("Extracted MCI ID:", mciId); // ✅ Log extracted mci_id value
    
            // ✅ Redirect based on mci_id presence
            if (!mciId) {
              console.log("MCI ID is missing or empty. Redirecting to Profile Page.");
              navigate("/profile"); // Redirect to profile if mci_id is missing or empty
            } else {
              console.log("MCI ID found:", mciId, "Redirecting to Landing Page.");
              navigate("/landing"); // Redirect to landing page if profile is complete
            }
          } catch (error) {
            console.error("Error fetching profile details:", error);
            alert("Could not retrieve profile details. You may need to complete your profile.");
            navigate("/profile"); // Redirect to profile page as a fallback
          }
          
      } else {
        console.error("Login Failed for User:", username);
        setError(response.data.message || "Invalid username or password!");
      }
    } catch (error) {
      console.error("Login error:", error);
      setError("An error occurred. Please try again later.");
    } finally {
      setLoading(false); // Stop loading
    }
  };
  const handleForgotPassword = () => {
    alert("Please Contact support@diabrainai.com");
  };
  return (
    <>
      <section className="dialog-section">
        <div style={{ display: "flex", alignItems: "center" }}>
          <h1 style={{ marginRight: "10px", textAlign: "left" }}>DiaBrain</h1>
        </div>
      </section>

      <div className="login-wrapper">
        <div className="login-container">
          <h2 className="sign-title" style={{ margin: "0" }}>
            <span className="text-dark" style={{ display: "block" }}>SIGN</span>
            <span className="main_title_c1">IN</span>
          </h2>

          {error && <p style={{ color: "red", textAlign: "center", fontWeight: "bold" }}>{error}</p>}

          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label style={{ fontWeight: "bold", fontSize: "18px" }}>Contact Number</label>
              <input 
                type="text" 
                placeholder="Enter your contact number" 
                value={username} 
                onChange={(e) => setUsername(e.target.value)} 
                required 
              />
            </div>

            <div className="form-group">
              <label style={{ fontWeight: "bold", fontSize: "18px" }}>Password</label>
              <input 
                type="password" 
                placeholder="Enter your password" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                required 
              />
            </div>

            <button type="submit" className="login-btn" disabled={loading}>
              {loading ? "Signing In..." : "Sign In"}
            </button>

            <a className="lfc_forget_pass" onClick={handleForgotPassword}>Forgot Your Password?</a>
            <br /><br />

            <span>New User?</span>
            <input 
              type="button" 
              className="login-btn" 
              value="Sign Up" 
              onClick={() => navigate("/signup")} 
            />
          </form>
        </div>
      </div>
    </>
  );
}

export default Login;
